import { GKButton, Grid2, Switch, Typography } from "components";
import { CompanySettingApi } from "interfaces/Settings";
import { Controller, useForm } from "react-hook-form";
import { useUpdateCompanySettingsMutation } from "store/features/CompanySetting";
import useDocumentTitle from "utils/useDocumentTitle";

type FormFields = {
  showZeroHoldingTables: boolean;
};

const generalOptions = [
  {
    name: "Show zero holdings in all data tables",
    fieldName: "showZeroHoldingTables",
    description: "Turn on to show zero balance holdings in all tables.",
  },
  {
    name: "Include zero holdings in Reports",
    fieldName: "showZeroHolding",
    description: "Turn on to include zero balance holdings in reports.",
  },
  {
    name: "Account for TDS in dividend accrual",
    fieldName: "deductTaxFromDividend",
    description: "Turn on to allow TDS in dividend accrual.",
  },
  {
    name: "Cash Entries for Mutual Fund Transactions",
    fieldName: "manageMfCashEntries",
    description:
      "Turn this toggle on to automatically add Deposit and Withdraw cash entries against purchase and redemption transactions of mutual funds.",
  },
];

interface Props {
  data: CompanySettingApi;
  companyId: string;
}

const GeneralPreferences = (props: Props) => {
  useDocumentTitle("General Preferences");

  const { data, companyId } = props;

  const [updateCompanySettings, { isLoading }] =
    useUpdateCompanySettingsMutation();

  const form = useForm({
    defaultValues: {
      showZeroHoldingTables: data?.showZeroHoldingTables || true,
      deductTaxFromDividend: data?.deductTaxFromDividend || false,
      showZeroHolding: data?.showZeroHolding || true,
      manageMfCashEntries: data?.manageMfCashEntries || false,
    },
    values: {
      showZeroHoldingTables: data?.showZeroHoldingTables || false,
      deductTaxFromDividend: data?.deductTaxFromDividend || false,
      showZeroHolding: data?.showZeroHolding || false,
      manageMfCashEntries: data?.manageMfCashEntries || false,
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit((values) => {
        updateCompanySettings({
          id: companyId,
          body: values,
        });
      })}
    >
      <Grid2 container spacing={2}>
        {generalOptions.map((dataItem, index) => (
          <>
            <Grid2 size={12} key={index}>
              <div style={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Controller
                  name={dataItem.fieldName as keyof FormFields}
                  control={form.control}
                  render={({ field }) => (
                    <Switch checked={field.value} onChange={field.onChange} />
                  )}
                />
                <Typography
                  fontSize={16}
                  fontWeight={400}
                  textTransform={"none"}
                >
                  {dataItem.name}
                </Typography>
              </div>
              <Typography
                ml={"42px"}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                {dataItem.description}
              </Typography>
            </Grid2>
          </>
        ))}

        {/* {twoWaySigning && (
          <Grid2 container size={12} spacing={2} ml={3}>
            <Grid2 size={4}>
              <Controller
                name="name"
                control={form.control}
                rules={{
                  required: {
                    value: true,
                    message: "Please enter name",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <GKTextField
                    {...field}
                    requiredField
                    inputLabel="Advisor Name"
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid2>
            <Grid2 size={4}>
              <Controller
                name="email"
                control={form.control}
                rules={{
                  required: {
                    value: true,
                    message: "Please enter email",
                  },
                  pattern: {
                    value: emailRegex,
                    message: "Please enter a valid mail",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <GKTextField
                    {...field}
                    requiredField
                    inputLabel="email"
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid2>
            <Grid2 size={4}>
              <Controller
                name="phoneNumber"
                control={form.control}
                rules={{
                  required: {
                    value: true,
                    message: "Please enter phone",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <PhoneInput
                    {...field}
                        inputLabel='Phone Number'
                    requiredField
                    onSelectChange={(event: any) => {
                      form.setValue("countryCode", event);
                    }}
                    onTextChange={(event: any) => {
                      field.onChange(event);
                    }}
                    onTextValue={field.value}
                    onSelectValue={form.getValues("countryCode")}
                    error={!!error || hasError}
                    helperText={error?.message}
                    hasError={hasError}
                    setHasError={setHasError}
                  />
                )}
              />
            </Grid2>
          </Grid2>
        )} */}

        <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
          <GKButton variant="contained" type="submit" loading={isLoading}>
            Save
          </GKButton>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default GeneralPreferences;
